<template>
  <div class="data-tag">
    <span>{{ displayName }}</span>
    <font-awesome-icon icon="times" @click="$emit('delete', tag)" />
  </div>
</template>

<script>
export default {
  name: 'DataTag',
  props: {
    tag: {
      type: [Object, String],
      required: true
    }
  },
  computed: {
    displayName() {
      if (typeof this.tag === 'string' || this.tag instanceof String) {
        return this.tag;
      } else {
        return this.tag.name;
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import '../styles/colors';
@import '../styles/variables';
.data-tag {
  display: flex;
  align-items: center;
  border: 1px solid $row-border;
  border-radius: 5px;
  background-color: $light-grey-2;
  margin: 0 5px;
  padding: 3px 2px;
  span {
    display: inline-block;
    margin-right: 5px;
  }
  svg {
    color: $row-border;
    margin-left: auto;
    &:hover {
      cursor: pointer;
      color: $red;
    }
  }
  &.sm {
    font-size: 0.8em;
    padding: 0 2px;
    height: 30px;
    font-weight: bold;
  }
}
</style>
